import type { EnvioCampana } from '../../lib/supabase';
import { enviosCampanaService, type RespaldoTransferencia } from '../../services/enviosCampanaService';
import type { ResultadoEnvioCampana } from '../../types/fondosCampana';
import type { AccionEnvioCampana } from './accionesEnvio';

export interface DatosOperacionEnvio {
  readonly accion: AccionEnvioCampana;
  readonly envio: EnvioCampana;
  readonly motivo: string;
  readonly descripcion: string;
  readonly declarado: boolean;
  /** Solo "corregir": el comprobante que reemplaza al actual. Sin él se conserva el que ya tiene el envío. */
  readonly respaldo?: RespaldoTransferencia;
}

/** Captura revisión y argumentos una vez; el hook reutiliza esta operación si el resultado es incierto. */
export function construirOperacionEnvio(datos: DatosOperacionEnvio, solicitudId: string): () => Promise<ResultadoEnvioCampana> {
  const comunes = { envioId: datos.envio.id, revision: datos.envio.revision, solicitudId };
  switch (datos.accion) {
    case 'confirmar': return () => enviosCampanaService.resolver({ ...comunes, decision: 'confirmado', nota: null });
    case 'observar': return () => enviosCampanaService.resolver({ ...comunes, decision: 'observado', nota: datos.motivo });
    case 'corregir': return () => enviosCampanaService.corregir({ ...comunes, descripcion: datos.descripcion || null,
      motivo: datos.motivo, respaldo: datos.respaldo });
    case 'cerrar': return () => enviosCampanaService.cerrarSinTransferencia({ ...comunes,
      noSeEjecuto: datos.declarado, motivo: datos.motivo });
  }
}

export function requiereMotivo(accion: AccionEnvioCampana): boolean {
  return ['observar', 'corregir', 'cerrar'].includes(accion);
}

export function requiereDeclaracion(accion: AccionEnvioCampana): boolean {
  return ['confirmar', 'cerrar'].includes(accion);
}
